module.exports = __webpack_public_path__ + "img/customer-icon-4.a10a0932.png";